export default __webpack_public_path__ + "static/media/News & Announcements.bf2477d7.svg";